import { render } from "./JobQuoteCard.vue?vue&type=template&id=56b799f8"
import script from "./JobQuoteCard.vue?vue&type=script&lang=js"
export * from "./JobQuoteCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__